import type { AxiosInstance } from 'axios';

import type { Event, Tag } from '@/models/event';

export type UpdateEvent = {
   eventId: string;
   data: Partial<Event>;
};

export type DeleteTag = {
   tagId: string;
};

export type AddTag = {
   label: string;
   userId: string;
};

class EventService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async updateEvent({ eventId, data }: UpdateEvent) {
      await this.provider.post('rest/events/mutate', {
         mutate: [
            {
               operation: 'update',
               key: eventId,
               attributes: data,
            },
         ],
      });
   }

   async getTags(): Promise<Tag[]> {
      try {
         const response = await this.provider.post(`/tags/search?limit=100`);
         return response.data.data;
      } catch (error) {
         console.error('Error fetching tags:', error);
         throw error;
      }
   }

   async deleteTag({ tagId }: DeleteTag) {
      try {
         const response = await this.provider.delete(`/tags/${tagId}`);
         return response.data.data;
      } catch (error) {
         console.error('Error fetching tags:', error);
         throw error;
      }
   }

   async addTag({ label, userId }: AddTag) {
      try {
         const response = await this.provider.post(`/tags/`, {
            label,
            creator_id: userId,
         });
         return response.data.data;
      } catch (error) {
         console.error('Error adding tags:', error);
         throw error;
      }
   }
}

export default EventService;
